/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".images-container[_ngcontent-%COMP%]{margin:15px auto}.images-container[_ngcontent-%COMP%]   .images-slider[_ngcontent-%COMP%]{width:100%;margin:15px 0}.images-container[_ngcontent-%COMP%]   .images-slider[_ngcontent-%COMP%]:nth-of-type(1){margin-bottom:0}@media only screen and (min-width:960px){.images-container[_ngcontent-%COMP%]{height:600px;overflow:hidden}.images-container[_ngcontent-%COMP%]   .images-slider[_ngcontent-%COMP%]{width:50%;margin:0 7.5px}}.title-decoration[_ngcontent-%COMP%]{width:20px}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/downtown-life/gallery.component.scss.shim.ngstyle.js.pre-build-optimizer.js